module.exports = __webpack_public_path__ + "static/media/11_r_stena_80.57_0.7346c04a.png";